import { useState } from "react";

export default function QuestionPanel({ onSubmit }) {
  const [counts, setCounts] = useState({
    rectangle: "",
    circle: "",
    triangle: "",
  });

  return (
    <div className="p-10 text-center space-y-4">
      <h2 className="text-2xl mb-4">How many did you see?</h2>

      <div>
        <label>Red Rectangles:</label>
        <input
          type="number"
          className="border p-2 ml-2"
          onChange={(e) =>
            setCounts({ ...counts, rectangle: e.target.value })
          }
        />
      </div>

      <div>
        <label>Green Circles:</label>
        <input
          type="number"
          className="border p-2 ml-2"
          onChange={(e) =>
            setCounts({ ...counts, circle: e.target.value })
          }
        />
      </div>

      <div>
        <label>Blue Triangles:</label>
        <input
          type="number"
          className="border p-2 ml-2"
          onChange={(e) =>
            setCounts({ ...counts, triangle: e.target.value })
          }
        />
      </div>

      <button
        onClick={() => onSubmit(counts)}
        className="bg-green-600 text-white px-6 py-2 mt-4"
      >
        Submit
      </button>
    </div>
  );
}
